import { render, staticRenderFns } from "./_send-invitation.vue?vue&type=template&id=386e9b58&"
import script from "./_send-invitation.vue?vue&type=script&lang=js&"
export * from "./_send-invitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports